import React, { useState, useEffect } from 'react';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = ({ embedded = false }) => {
  const [currentSection, setCurrentSection] = useState('overview');

  // Scroll al top cuando se monta la página completa (no en modal embebido)
  useEffect(() => {
    if (!embedded) {
      window.scrollTo(0, 0);
    }
  }, [embedded]);

  const sections = [
    { id: 'overview', title: 'Resumen Ejecutivo', icon: 'fas fa-eye' },
    { id: 'collection', title: 'Recopilación de Datos', icon: 'fas fa-database' },
    { id: 'usage', title: 'Uso de Información', icon: 'fas fa-cogs' },
    { id: 'sharing', title: 'Compartir Información', icon: 'fas fa-share-alt' },
    { id: 'security', title: 'Seguridad y Protección', icon: 'fas fa-shield-alt' },
    { id: 'rights', title: 'Derechos del Usuario', icon: 'fas fa-user-check' },
    { id: 'cookies', title: 'Cookies y Tecnologías', icon: 'fas fa-cookie-bite' },
    { id: 'children', title: 'Protección de Menores', icon: 'fas fa-baby' },
    { id: 'international', title: 'Transferencias Internacionales', icon: 'fas fa-globe' },
    { id: 'updates', title: 'Actualizaciones y Contacto', icon: 'fas fa-phone' }
  ];

  const renderSectionContent = (sectionId) => {
    switch (sectionId) {
      case 'overview':
        return (
          <div className="privacy-section-content">
            <h3>1. Resumen Ejecutivo</h3>
            
            <h4>1.1 Compromiso con la Privacidad</h4>
            <p>En Javiland, la privacidad y protección de sus datos personales es una prioridad fundamental. Esta Política de Privacidad describe cómo recopilamos, utilizamos, protegemos y compartimos su información personal cuando utiliza nuestros servicios en nuestra tienda virtual.</p>
            
            <h4>1.2 Alcance de la Política</h4>
            <p>Esta política se aplica a todos los servicios de Javiland como tienda virtual, incluyendo:</p>
            <ul>
              <li>Tienda virtual y plataforma web</li>
              <li>Servicios de e-commerce y gestión de productos</li>
              <li>Plataforma de yoga y bienestar</li>
              <li>Servicios especializados para la comunidad</li>
              <li>Comunicaciones y marketing digital</li>
            </ul>
            
            <h4>1.3 Principios Fundamentales</h4>
            <p>Nos comprometemos a:</p>
            <ul>
              <li>Recopilar solo la información necesaria para nuestros servicios</li>
              <li>Proteger su información con las mejores prácticas de seguridad</li>
              <li>Ser transparentes sobre cómo utilizamos sus datos</li>
              <li>Respetar sus derechos de privacidad</li>
              <li>Cumplir con la legislación colombiana de protección de datos</li>
            </ul>
          </div>
        );

      case 'collection':
        return (
          <div className="privacy-section-content">
            <h3>2. Recopilación de Información</h3>
            
            <h4>2.1 Información que Recopilamos</h4>
            <p>Recopilamos diferentes tipos de información para proporcionar y mejorar nuestros servicios:</p>
            
            <h5>Información Personal Identificable:</h5>
            <ul>
              <li>Nombre completo, dirección de email y número de teléfono</li>
              <li>Información de perfil (intereses, preferencias, áreas de especialización)</li>
              <li>Información de cuenta (credenciales de acceso, historial de actividad)</li>
            </ul>
            
            <h5>Información de Transacciones (Tienda Virtual):</h5>
            <ul>
              <li>Historial de compras y pagos en línea</li>
              <li>Productos y servicios adquiridos</li>
              <li>Información de facturación electrónica y dirección de envío</li>
            </ul>
            
            <h5>Información Técnica:</h5>
            <ul>
              <li>Dirección IP y datos de localización</li>
              <li>Información del dispositivo y navegador</li>
              <li>Datos de uso y analytics</li>
            </ul>
            
            <h4>2.2 Métodos de Recopilación</h4>
            <p>Recopilamos información a través de:</p>
            <ul>
              <li>Formularios de registro y contacto</li>
              <li>Interacciones con nuestros servicios</li>
              <li>Cookies y tecnologías similares</li>
              <li>Comunicaciones directas con usted</li>
              <li>Integraciones con terceros autorizados</li>
            </ul>
          </div>
        );

      case 'usage':
        return (
          <div className="privacy-section-content">
            <h3>3. Uso de Información</h3>
            
            <h4>3.1 Propósitos Principales</h4>
            <p>Utilizamos su información personal para los siguientes propósitos:</p>
            
            <h5>Provisión de Servicios:</h5>
            <ul>
              <li>Crear y gestionar su cuenta de usuario</li>
              <li>Procesar transacciones y pagos</li>
              <li>Proporcionar soporte técnico y atención al cliente</li>
              <li>Personalizar su experiencia en la plataforma</li>
            </ul>
            
            <h5>Comunicación:</h5>
            <ul>
              <li>Enviar confirmaciones de transacciones</li>
              <li>Notificar actualizaciones de servicios</li>
              <li>Compartir información relevante sobre productos</li>
              <li>Responder a sus consultas y solicitudes</li>
            </ul>
            
            <h5>Mejora de Servicios:</h5>
            <ul>
              <li>Analizar patrones de uso para optimizar la plataforma</li>
              <li>Desarrollar nuevos productos y funcionalidades</li>
              <li>Conducir investigaciones de mercado y análisis</li>
              <li>Prevenir fraudes y mejorar la seguridad</li>
            </ul>
            
            <h4>3.2 Base Legal</h4>
            <p>El procesamiento de sus datos se basa en:</p>
            <ul>
              <li><strong>Consentimiento:</strong> Cuando usted nos autoriza explícitamente</li>
              <li><strong>Ejecución de Contrato:</strong> Para proporcionar los servicios solicitados</li>
              <li><strong>Interés Legítimo:</strong> Para mejorar nuestros servicios y prevenir fraudes</li>
              <li><strong>Obligación Legal:</strong> Para cumplir con requisitos regulatorios</li>
            </ul>
          </div>
        );

      case 'sharing':
        return (
          <div className="privacy-section-content">
            <h3>4. Compartir Información</h3>
            
            <h4>4.1 Principio de No Compartir</h4>
            <p>Javiland no vende, alquila ni comercializa su información personal con terceros con fines comerciales. Solo compartimos información en las siguientes circunstancias:</p>
            
            <h4>4.2 Compartir con Proveedores de Servicios</h4>
            <p>Podemos compartir información con proveedores de servicios que nos ayudan a:</p>
            <ul>
              <li>Procesar pagos y transacciones (incluida la pasarela <strong>Wompi</strong> para compras en la tienda)</li>
              <li>Gestionar infraestructura tecnológica</li>
              <li>Proporcionar servicios de análisis y marketing</li>
              <li>Ofrecer soporte técnico y atención al cliente</li>
            </ul>
            
            <h4>4.3 Compartir por Requisitos Legales</h4>
            <p>Podemos divulgar información cuando:</p>
            <ul>
              <li>Sea requerido por ley o proceso legal</li>
              <li>Sea necesario para proteger nuestros derechos y propiedad</li>
              <li>Sea esencial para la seguridad de nuestros usuarios</li>
              <li>Exista consentimiento explícito de su parte</li>
            </ul>
            
            <h4>4.4 Transferencias Corporativas</h4>
            <p>En caso de fusión, adquisición o venta de activos, su información personal puede ser transferida como parte de la transacción. En tales casos, notificaremos a los usuarios afectados.</p>
            
            <h4>4.5 Agregación y Anonimización</h4>
            <p>Podemos compartir información agregada y anonimizada para análisis estadísticos, siempre que no permita la identificación individual de usuarios.</p>
          </div>
        );

      case 'security':
        return (
          <div className="privacy-section-content">
            <h3>5. Seguridad y Protección</h3>
            
            <h4>5.1 Medidas de Seguridad Implementadas</h4>
            <p>Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal:</p>
            
            <h5>Seguridad Técnica:</h5>
            <ul>
              <li>Encriptación SSL/TLS para todas las transmisiones de datos</li>
              <li>Encriptación de contraseñas con algoritmos seguros</li>
              <li>Firewalls y sistemas de detección de intrusiones</li>
              <li>Monitoreo continuo de seguridad 24/7</li>
              <li>Copias de seguridad regulares y seguras</li>
            </ul>
            
            <h5>Seguridad Organizativa:</h5>
            <ul>
              <li>Acceso restringido a información personal solo para personal autorizado</li>
              <li>Capacitación regular del personal en prácticas de seguridad</li>
              <li>Políticas y procedimientos de seguridad documentados</li>
              <li>Auditorías regulares de seguridad</li>
            </ul>
            
            <h4>5.2 Retención de Datos</h4>
            <p>Conservamos su información personal solo durante el tiempo necesario para:</p>
            <ul>
              <li>Proporcionar nuestros servicios</li>
              <li>Cumplir con obligaciones legales</li>
              <li>Resolver disputas y hacer cumplir acuerdos</li>
              <li>Mejorar nuestros servicios</li>
            </ul>
            
            <h4>5.3 Incidentes de Seguridad</h4>
            <p>En caso de una violación de seguridad que afecte su información personal:</p>
            <ul>
              <li>Notificaremos a las autoridades competentes dentro de 72 horas</li>
              <li>Le informaremos a usted sin demora indebida</li>
              <li>Implementaremos medidas correctivas inmediatas</li>
              <li>Documentaremos el incidente y las acciones tomadas</li>
            </ul>
          </div>
        );

      case 'rights':
        return (
          <div className="privacy-section-content">
            <h3>6. Derechos del Usuario</h3>
            
            <h4>6.1 Derechos ARCO</h4>
            <p>Conforme a la legislación colombiana, usted tiene los siguientes derechos:</p>
            
            <h5>Derecho de Acceso:</h5>
            <p>Puede solicitar información sobre qué datos personales tenemos sobre usted y cómo los utilizamos.</p>
            
            <h5>Derecho de Rectificación:</h5>
            <p>Puede solicitar la corrección de datos personales inexactos o incompletos.</p>
            
            <h5>Derecho de Cancelación:</h5>
            <p>Puede solicitar la eliminación de sus datos personales de nuestros sistemas.</p>
            
            <h5>Derecho de Oposición:</h5>
            <p>Puede oponerse al procesamiento de sus datos personales en ciertas circunstancias.</p>
            
            <h4>6.2 Derechos Adicionales</h4>
            <p>También tiene derecho a:</p>
            <ul>
              <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
              <li><strong>Limitación:</strong> Restringir el procesamiento de sus datos</li>
              <li><strong>Revocación:</strong> Retirar su consentimiento en cualquier momento</li>
              <li><strong>Reclamo:</strong> Presentar una queja ante la autoridad competente</li>
            </ul>
            
            <h4>6.3 Ejercicio de Derechos — ¿Cómo lo hace Javiland hoy?</h4>
            <p>Hoy el proceso es <strong>manual y por correo</strong>. No hay aún un formulario automático de ARCO en la web; atendemos cada solicitud de forma personalizada:</p>
            <ol>
              <li>Escribe a <strong>support@javiland.com</strong> con asunto «Solicitud ARCO — [Acceso / Rectificación / Cancelación / Oposición]».</li>
              <li>Incluye tu nombre completo y el correo con el que compraste o te registraste en Javiland (tienda o comunidad).</li>
              <li>Indica claramente qué derecho ejerces y qué datos quieres consultar, corregir o eliminar.</li>
              <li>Podemos pedirte datos adicionales para <strong>verificar tu identidad</strong> antes de actuar.</li>
            </ol>
            <p><strong>Cancelación / eliminación de datos:</strong> eliminamos o anonimizamos lo posible en cuentas de comunidad, listas de interés y perfiles no vinculados a obligaciones legales. Los datos de <strong>pedidos pagados, facturación y contabilidad</strong> pueden conservarse el tiempo que exija la ley colombiana (no siempre es posible borrar por completo un historial de compra, pero sí limitar su uso a fines legales).</p>
            <p>Registramos la solicitud internamente y respondemos por correo. Si tienes cuenta en <a href="/comunidad">Comunidad Javiland</a>, también puedes actualizar parte de tu perfil desde allí.</p>
            
            <h4>6.4 Plazos de Respuesta</h4>
            <p>Nos comprometemos a responder a sus solicitudes dentro de los siguientes plazos:</p>
            <ul>
              <li><strong>Solicitudes de acceso:</strong> 15 días hábiles</li>
              <li><strong>Solicitudes de rectificación:</strong> 10 días hábiles</li>
              <li><strong>Solicitudes de cancelación:</strong> 15 días hábiles</li>
              <li><strong>Solicitudes de oposición:</strong> 10 días hábiles</li>
            </ul>
          </div>
        );

      case 'cookies':
        return (
          <div className="privacy-section-content">
            <h3>7. Cookies y Tecnologías Similares</h3>
            
            <h4>7.1 ¿Qué son las Cookies?</h4>
            <p>Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. Nos ayudan a mejorar su experiencia y proporcionar funcionalidades personalizadas.</p>
            
            <h4>7.2 Tipos de Cookies que Utilizamos</h4>
            
            <h5>Cookies Esenciales:</h5>
            <ul>
              <li>Son necesarias para el funcionamiento básico del sitio</li>
              <li>Permiten la autenticación y sesiones de usuario</li>
              <li>Gestionan el carrito de compras y preferencias</li>
              <li>No se pueden deshabilitar sin afectar la funcionalidad</li>
            </ul>
            
            <h5>Cookies de Rendimiento:</h5>
            <ul>
              <li>Recopilan información sobre cómo utiliza nuestro sitio</li>
              <li>Nos ayudan a identificar y resolver problemas de rendimiento</li>
              <li>Mejoran la velocidad y funcionalidad del sitio</li>
              <li>Pueden ser deshabilitadas sin afectar la experiencia básica</li>
            </ul>
            
            <h5>Cookies de Funcionalidad:</h5>
            <ul>
              <li>Recuerdan sus preferencias y configuraciones</li>
              <li>Personalizan el contenido y la experiencia</li>
              <li>Permiten funcionalidades avanzadas</li>
              <li>Mejoran la usabilidad del sitio</li>
            </ul>
            
            <h5>Cookies de Marketing:</h5>
            <ul>
              <li>Se utilizan para mostrar publicidad relevante</li>
              <li>Rastrean la efectividad de campañas publicitarias</li>
              <li>Permiten la personalización de contenido promocional</li>
              <li>Siempre requieren su consentimiento explícito</li>
            </ul>
            
            <h4>7.3 Gestión de Cookies</h4>
            <p>Puede gestionar sus preferencias de cookies a través de:</p>
            <ul>
              <li>Configuración de su navegador web</li>
              <li>Nuestro panel de preferencias de cookies</li>
              <li>Configuración de su cuenta de usuario</li>
              <li>Herramientas de terceros de gestión de privacidad</li>
            </ul>
          </div>
        );

      case 'children':
        return (
          <div className="privacy-section-content">
            <h3>8. Protección de Menores</h3>
            
            <h4>8.1 Edad Mínima</h4>
            <p>Nuestros servicios no están dirigidos a menores de 18 años. No recopilamos intencionalmente información personal de menores de edad.</p>
            
            <h4>8.2 Verificación de Edad</h4>
            <p>Al registrarse en nuestros servicios, usted confirma que:</p>
            <ul>
              <li>Tiene al menos 18 años de edad</li>
              <li>Tiene capacidad legal para celebrar contratos</li>
              <li>Puede proporcionar consentimiento válido</li>
            </ul>
            
            <h4>8.3 Uso por Menores Supervisados</h4>
            <p>Si un menor utiliza nuestros servicios bajo supervisión de un adulto:</p>
            <ul>
              <li>El adulto es responsable de la información del menor</li>
              <li>Debe proporcionar consentimiento válido</li>
              <li>Debe supervisar el uso apropiado de los servicios</li>
              <li>Puede solicitar la eliminación de datos del menor</li>
            </ul>
            
            <h4>8.4 Reporte de Menores</h4>
            <p>Si descubrimos que hemos recopilado información de un menor sin consentimiento parental:</p>
            <ul>
              <li>Eliminaremos inmediatamente la información</li>
              <li>Notificaremos a los padres o tutores</li>
              <li>Tomaremos medidas para prevenir futuras recopilaciones</li>
              <li>Documentaremos el incidente para auditoría</li>
            </ul>
          </div>
        );

      case 'international':
        return (
          <div className="privacy-section-content">
            <h3>9. Transferencias Internacionales</h3>
            
            <h4>9.1 Alcance de Transferencias</h4>
            <p>Javiland opera principalmente en Colombia, pero algunos de nuestros servicios pueden involucrar transferencias internacionales de datos a:</p>
            <ul>
              <li>Proveedores de servicios en la nube</li>
              <li>Plataformas de análisis y marketing</li>
              <li>Servicios de procesamiento de pagos</li>
              <li>Herramientas de comunicación y colaboración</li>
            </ul>
            
            <h4>9.2 Protecciones Aplicadas</h4>
            <p>Para todas las transferencias internacionales, implementamos las siguientes protecciones:</p>
            
            <h5>Cláusulas Contractuales Estándar:</h5>
            <ul>
              <li>Acuerdos de procesamiento de datos (DPA)</li>
              <li>Cláusulas de protección de datos aprobadas</li>
              <li>Compromisos de confidencialidad y seguridad</li>
            </ul>
            
            <h5>Certificaciones de Adecuación:</h5>
            <ul>
              <li>Verificación de que el país destino tiene nivel adecuado de protección</li>
              <li>Certificaciones de cumplimiento internacional</li>
              <li>Auditorías regulares de proveedores internacionales</li>
            </ul>
            
            <h4>9.3 Países de Destino</h4>
            <p>Actualmente transferimos datos a países que incluyen:</p>
            <ul>
              <li><strong>Estados Unidos:</strong> Servicios en la nube y analytics</li>
              <li><strong>Unión Europea:</strong> Herramientas de marketing y comunicación</li>
              <li><strong>Canadá:</strong> Servicios de procesamiento de pagos</li>
              <li><strong>Colombia:</strong> Almacenamiento principal y procesamiento</li>
            </ul>
            
            <h4>9.4 Derechos del Usuario</h4>
            <p>Usted tiene derecho a:</p>
            <ul>
              <li>Ser informado sobre transferencias internacionales</li>
              <li>Conocer las protecciones aplicadas</li>
              <li>Oponerse a transferencias específicas</li>
              <li>Solicitar información sobre países de destino</li>
            </ul>
          </div>
        );

      case 'updates':
        return (
          <div className="privacy-section-content">
            <h3>10. Actualizaciones y Contacto</h3>
            
            <h4>10.1 Actualizaciones de la Política</h4>
            <p>Esta Política de Privacidad puede ser actualizada periódicamente para reflejar:</p>
            <ul>
              <li>Cambios en nuestras prácticas de privacidad</li>
              <li>Nuevas funcionalidades y servicios</li>
              <li>Actualizaciones en la legislación aplicable</li>
              <li>Mejoras en nuestras medidas de seguridad</li>
            </ul>
            
            <h4>10.2 Notificación de Cambios</h4>
            <p>Cuando realicemos cambios significativos en esta política:</p>
            <ul>
              <li>Le notificaremos por email al menos 30 días antes</li>
              <li>Publicaremos un aviso prominente en nuestro sitio web</li>
              <li>Actualizaremos la fecha de "Última Modificación"</li>
              <li>Le daremos la opción de aceptar o rechazar los cambios</li>
            </ul>
            
            <h4>10.3 Contacto para Consultas</h4>
            <p>Si tiene preguntas sobre esta Política de Privacidad o nuestras prácticas de datos, puede contactarnos a través de:</p>
            
            <div className="contact-methods">
              <div className="contact-method">
                <h5><i className="fas fa-envelope"></i> Contacto</h5>
                <p><strong>Email:</strong> support@javiland.com</p>
                <small>Respuesta en 24-48 horas</small>
              </div>
              
              <div className="contact-method">
                <h5><i className="fas fa-map-marker-alt"></i> Ubicación</h5>
                <p><strong>Tienda Virtual</strong></p>
                <small>Operamos desde Bogotá, Colombia</small>
              </div>
            </div>
            
            <h4>10.4 Protección de Datos</h4>
            <p>Para asuntos específicos de protección de datos, puede contactarnos al mismo email:</p>
            <ul>
              <li><strong>Email:</strong> support@javiland.com</li>
              <li><strong>Horario de atención:</strong> Lunes a Viernes, 9:00 AM - 6:00 PM</li>
            </ul>
            
            <h4>10.5 Autoridad Supervisora</h4>
            <p>Si no está satisfecho con nuestra respuesta, puede contactar a la Superintendencia de Industria y Comercio (SIC) de Colombia, que es la autoridad competente en materia de protección de datos personales.</p>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className={`privacy-page${embedded ? ' privacy-page--embedded' : ''}`}>
      <div className="privacy-container">
        <div className="privacy-header">
          <button 
            className="back-button"
            onClick={() => {
              window.history.pushState({}, '', '/');
              window.dispatchEvent(new PopStateEvent('popstate'));
            }}
          >
            <i className="fas fa-arrow-left"></i>
            Volver al Inicio
          </button>
          <div className="privacy-logo">
            <img src="/images/Logo_Javiland_Largo.png" alt="Javiland" />
          </div>
          <h1>Política de Privacidad</h1>
          <p className="privacy-subtitle">Última actualización: {new Date().toLocaleDateString('es-CO')}</p>
        </div>

        <div className="privacy-body">
          {!embedded ? (
          <div className="privacy-sidebar">
            <nav className="privacy-navigation">
              {sections.map((section) => (
                <button
                  key={section.id}
                  className={`privacy-nav-item ${currentSection === section.id ? 'active' : ''}`}
                  onClick={() => setCurrentSection(section.id)}
                >
                  <i className={section.icon}></i>
                  <span>{section.title}</span>
                </button>
              ))}
            </nav>
          </div>
          ) : null}

          <div className="privacy-content">
            {embedded ? (
              <div className="privacy-embedded-nav">
                <label htmlFor="privacy-section-select" className="privacy-sr-only">
                  Sección de la política
                </label>
                <select
                  id="privacy-section-select"
                  value={currentSection}
                  onChange={(e) => setCurrentSection(e.target.value)}
                  aria-label="Sección de la política de privacidad"
                >
                  {sections.map((section) => (
                    <option key={section.id} value={section.id}>
                      {section.title}
                    </option>
                  ))}
                </select>
              </div>
            ) : null}
            <div className="privacy-scrollable">
              {renderSectionContent(currentSection)}
              
              <div className="privacy-footer">
                <h4>Nota Importante</h4>
                <p>Esta Política de Privacidad es parte integral de nuestros Términos y Condiciones. Al utilizar nuestros servicios, usted acepta tanto los términos como esta política de privacidad.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
